import { ComponentRenderHooks, ListItemsHooks } from "@launchos/plugins/types";
import LivePicture from "./component";

export const onComponentRender = (hook, payload, actions) => {
  if (hook.id === ComponentRenderHooks.WEBCOMPONENT && payload.type === "Picture") {
    return [LivePicture];
  }
};
